import { Directive, nextTick } from "vue";
import { scrollIntoViewIfNeeded } from "@/utils/scroll";

export const vScrollIntoView: Directive = (el, { value, oldValue }) => {
    if(value && !oldValue) {
        nextTick(() => {
            scrollIntoViewIfNeeded(el);
        });
    }
}
